import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { UpsertPortalUserInput, UpsertPortalUserPayload } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPSERT_CLIENT_PORTAL_USER = gql`
    mutation upsertClientPortalUser($input: UpsertPortalUserInput!){
        upsertClientPortalUser(input: $input){
            message
            errors {
                code
                message
            }
            result
        }
    }
`;

export const mutationUpsertClientPortalUser = async (
    client: ApolloClient<NormalizedCacheObject>,
    portalUserData: UpsertPortalUserInput
): Promise<UpsertPortalUserPayload | undefined> => {
    const {
        id,
        tenantId,
        email,
        firstName,
        lastName,
        customerRole,
        subscriptionRole
    } = portalUserData;
    const { data, errors } = await client.mutate<{ upsertClientPortalUser: UpsertPortalUserPayload }>({
        variables: {
            input: {
                id,
                tenantId,
                email,
                firstName,
                lastName,
                customerRole,
                subscriptionRole
            }
        },
        mutation: MUTATION_UPSERT_CLIENT_PORTAL_USER
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // Friendly error to active user
        throw new Error('An error has occurred during the client portal user save.');
    }
    if (data && data.upsertClientPortalUser) {
        return data.upsertClientPortalUser;
    }
    return undefined;
};